import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { Product } from "constants/modelCompareData/types";
import { readersAndIntercom } from "../product-list-groups/readersAndIntercom";
import image from "../../assets/door-access/readers-and-intercoms/g6-entry.png";

export const g6Entry: Product = {
  id: "g6Entry",
  productTitle: "G6 Entry",
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/door-access/uvc-g6-entry`],
  storePathParts: {
    productSlug: "uvc-g6-entry",
    collectionSlug: "doorbell-entry",
    category: "door-access-readers",
  },
  description: "g6Entry.description",
  image: {
    src: image,
    width: 200,
    height: 160,
  },
  productListGroup: readersAndIntercom,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '176 x 45 x 29.6 mm\n(6.9 x 1.8 x 1.2")',
      },
    },
    {
      propertyId: "cameraReader",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "twoWayIntercom",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "nfcCard",
      value: { type: "boolean", value: true },
    },
    { propertyId: "directory", value: { type: "boolean", value: false } },
    { propertyId: "pinAccess", value: { type: "boolean", value: false } },
    {
      propertyId: "touchPassSupport",
      value: { type: "string", value: "Apple Wallet\nGoogle Wallet" },
    },
    {
      propertyId: "mobileAppAccess",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "outdoorReady",
      value: { type: "string", value: "IP55" },
    },
    {
      propertyId: "readerPowerMethod",
      value: { type: "string", value: "PoE+" },
    },
  ],
};
